import { useMemo } from 'react'
import type { LevelMeta } from '@/game/levels'
import { buildGridState } from '@/game/engine'

export const BOARD_TILE_SIZE = 1
export const BOARD_TILE_GAP = 0.08

export interface CellInfo {
  x: number
  y: number
  tile: string
}

export interface BoardLayout {
  rows: number
  cols: number
  originX: number
  originZ: number
  tileSize: number
  gap: number
  toWorld: (x: number, y: number) => [number, number, number]
  extent: number
}

export function useBoardLayout(level: LevelMeta): BoardLayout {
  return useMemo(() => {
    const state = buildGridState(level.grid)
    const rows = state.rows
    const cols = state.cols
    const tileSize = BOARD_TILE_SIZE
    const gap = BOARD_TILE_GAP
    const pitch = tileSize + gap
    const originX = (-(cols - 1) * pitch) / 2
    const originZ = (-(rows - 1) * pitch) / 2
    const toWorld = (x: number, y: number): [number, number, number] => [
      originX + x * pitch,
      0,
      originZ + y * pitch,
    ]
    const extent = Math.max(cols, rows) * pitch
    return { rows, cols, originX, originZ, tileSize, gap, toWorld, extent }
  }, [level.grid])
}
